import { ChangeDetectionStrategy, Component, EventEmitter,
  Input, OnChanges, OnInit, Output, SimpleChanges
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DropdownSelectList } from '@interfaces/i-dropdown-select.interface';
import { rotateAnimation } from "@app/shared/animations/rotate.animation";
@Component({
  selector: 'app-dropdown-select',
  templateUrl: './dropdown-select.component.html',
  styleUrls: ['./dropdown-select.component.scss'],
  animations: [rotateAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownSelectComponent implements OnInit, OnChanges {

  @Input() form: UntypedFormGroup;
  @Input() isError: boolean = false;
  @Input() show = false;
  @Input() title: string;
  @Input() optionList: DropdownSelectList[] = [];
  @Input() type = '';
  @Input() additionalClass = '';
  @Input() additionalClassTitle = '';
  @Input() additionalClassIcon = '';
  @Input() cutTextLength: number = 1000;
  @Input() enableClearOption = false;
  @Input() enableCategory = false;
  @Input() isCompleteBible = false;
  @Output() emitOption: EventEmitter<string> = new EventEmitter<string>();
  @Output() emitCategory: EventEmitter<string> = new EventEmitter<string>();
  @Output() emitItemChapter: EventEmitter<Event> = new EventEmitter();
  @Output() emitError: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isOpen: boolean = false;
  isOpenSubitem = false;
  public isChosenOption: boolean = false;
  isTouched = false;
  private isAlreadyAssigned = false;
  private _currentValue: DropdownSelectList;
  private _currentCategory: any;
  private _title: string = '';
  openIndex: number | null = null; // Índice del submenú abierto
  currentBookWithChapters: ''
  _listChapter = [];
  _listCategory = [];
  _currentChapter: DropdownSelectList;
  viewMode: 'books' | 'chapters' = 'books'; // Inicialmente mostrar libros

  get currentValue() {
    return this._currentValue;
  }

  get currentCategory() {
    return this._currentCategory;
  }

  get listChapter() {
    return this._listChapter;
  }

  get currentChapter() {
    return this._currentChapter;
  }

  get listCategory() {
    return this._listCategory;
  }

  @Input()
  set currentValue(value: DropdownSelectList) {
    this._currentValue = value;
    if (this._currentValue) {
      this.isChosenOption = true;
      this.title = this.currentValue.name;
    }
  }

  @Input() set hasClearDropdown(value: boolean) {
    if (value) {
      this.isChosenOption = false;
      this.title = this._title || this.title;
    }
  }

  @Input()
  set currentCategory(value: any) {
    this._currentCategory = value;
  }

  @Input()
  set listChapter(value: any) {
    this._listChapter = value;
    this.currentBookWithChapters = this._listChapter[0]?.bookId;
  }

  @Input()
  set currentChapter(value: any) {
    this._currentChapter = value;
  }

  @Input()
  set listCategory(value: any) {
    this._listCategory = value;
  }

  constructor() { }

  ngOnInit(): void {
   this._title = this.title;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.currentValue && this.currentValue.name && !this.isAlreadyAssigned) {
      this.isAlreadyAssigned = true;
      this.setInitialValue();
    }
  }

  private setInitialValue() {
    if (this.currentValue) {
      this.isChosenOption = true;
      this.title = this.currentValue.name;
    }
  }

  public toggleShowOptions(): void {
    this.isOpen = !this.isOpen
    if (this.isOpen) {
      this.isTouched = true;
    }
  }

  toggleShowSubItem(index: number): void {
    this.openIndex = this.openIndex === index ? null : index;
    this.viewMode = 'chapters';
  }

  public sendOption(option: DropdownSelectList): void {
    if (this.type === 'book') {
      if (!this.show) {
        this.viewMode = 'chapters';
        if (this.currentValue?.value === option.value) {
          this.viewMode = 'chapters';
          return;
        }
      }
    } else {
      this.isOpen = false; 
    }

    this.currentValue = option;
    this.title = option.name;
    this.isChosenOption = true;
    this.emitOption.emit(option.value);
  }

  sendCategory(category: any): void {
    this.emitCategory.emit(category);
  }

  public goBackToBooks(): void {
    this.viewMode = 'books';
  }

  clear(): void {
    this.title = this._title;
    this.isChosenOption = false;
    this.emitOption.emit(null);
  }

  public trackByIdx(index: number, item: string): string {
    return `${index}-${item}`;
  }

  public clickOutSide(): void {
    if (this.isOpen) {
      this.isOpen = false;
      this.viewMode = 'books';
      if (!this.isChosenOption)
        this.emitOption.emit(undefined);
    }
  }

  filterChapter(itemChapter: any):void {
    this.emitItemChapter.emit(itemChapter);
    this.viewMode = 'books';
  }

}
